// extracted by mini-css-extract-plugin
export default {"focusLink":"focusLink---So3kg","showOnFocus":"showOnFocus---xQ6zx"};